import { BaseError } from '@hsp/utilities';

import { s } from 'utilities/strings';

export class TokenExpiredError extends BaseError {
  constructor() {
    super(s('Api.Token.Expired'));
  }
}
